import { Component } from "react";
import ErrorRetry from "components/ErrorRetry";
import {
    ERROR_SEVERITY,
    ERROR_SOURCE,
    logFrontendError,
} from "utils/errorLogger";

class ErrorBoundary extends Component {
    state = { hasError: false };

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, info) {
        logFrontendError({
            message: error?.message,
            stack: error?.stack,
            componentStack: info?.componentStack,
            source: ERROR_SOURCE.RENDER,
            severity: ERROR_SEVERITY.FATAL,
        });
    }

    render() {
        if (this.state.hasError) {
            return (
                <ErrorRetry
                    message="Something went wrong. Please refresh the page."
                    onRetry={() => window.location.reload()}
                />
            );
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
